const staticPath = {
  file: '',
  wstatic: 'https://wstatic-cdn.plaync.com',
  local: 'https://op-wstatic.ncsoft.com',
  op: 'https://op-wstatic.ncsoft.com',
  rc: 'https://rc-wstatic.plaync.co.kr',
  live: 'https://wstatic-cdn.plaync.com'
};

export default (env) => {
  return staticPath[env];
};
